import React, { useMemo } from 'react'
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from 'reactstrap'
import { rj, useRj, useRunRj } from 'react-rocketjump'
import { ajax } from 'rxjs/ajax'

const ModalRimanenze = ({ ordine, isOpen, toggle, runAvanzamentiCommesse, filtersToUse }) => {
  const RimanenzeState = rj(() =>
    ajax.getJSON(
      `/api/planner/ordini/${ordine.id}/rimanenze-attivita-operatore`
    )
  )

  const CompletateRimanenzeState = rj(() =>
    ajax.getJSON(`/api/planner/ordini/${ordine.id}/completa-attivita-operatore`)
  )

  const [{ data: rimanenze, loading }] = useRunRj(RimanenzeState)
  const [{}, { run: runCompletateRimanenze }] = useRj(
    CompletateRimanenzeState,
    { initialData: {} }
  )

  const thColumnsPostazioni = useMemo(() => {
    if (!rimanenze) {
      return []
    }
    return Object.keys(rimanenze).map((config) => ({
      Header: config,
      accessor: config,
    }))
  }, [rimanenze])

  const [isSubmitting, setIsSubmitting] = React.useState(false)

  return (
    <Modal isOpen={isOpen !== null} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        Ordine attività rimanenze - {ordine?.ordine_data?.numero_commessa} -{' '}
        {ordine?.ordine_data?.cliente?.nome}
      </ModalHeader>
      <ModalBody style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        {loading && <Spinner />}
        {!loading && (
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Postazione</th>
                <th>Rimanenze</th>
              </tr>
            </thead>
            <tbody>
              {thColumnsPostazioni.map((th) => (
                <tr key={th.accessor}>
                  <td>
                    <strong>{th.Header}</strong>
                  </td>
                  <td>
                    {Object.values(
                      rimanenze[th.accessor]?.lavorazioni_pezzi
                    )?.map((item, index) => {
                      return (
                        <div key={index}>
                          <div
                            className="mt-1 mr-1"
                            style={{
                              color:
                                item.pezzi_eseguiti === item.pezzi_totali
                                  ? 'darkgreen'
                                  : 'red',
                            }}
                          >
                            {item.lavorazione}:{' '}
                            {item.pezzi_totali - item.pezzi_eseguiti} /{' '}
                            {item.pezzi_totali}
                          </div>
                        </div>
                      )
                    })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </ModalBody>
      <ModalFooter className="d-flex justify-content-between">
        <Button color="secondary" onClick={toggle}>
          Chiudi
        </Button>
        <Button
            disabled={isSubmitting}
          color="primary"
          onClick={() => {
            setIsSubmitting(true)
            runCompletateRimanenze
              .onSuccess(() => {
                setIsSubmitting(false)
                toggle()
                runAvanzamentiCommesse({...filtersToUse })
              })
              .run(ordine.id)
          }}
        >
            {isSubmitting && <Spinner size="sm" className="mr-1" />}
          Completa attività
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ModalRimanenze
